import { AdjustedGrade, Grade } from "../types/inspection";

export const GRADE_TYPE_CONDITION = 1;
export const GRADE_TYPE_MANAGEMENT = 2;

const calculateManagementGrade = (grades: Grade[]) => {
    let totalManagement = 0;
    let maxManagement = 0;
    grades.filter(grade => grade.type === GRADE_TYPE_MANAGEMENT && grade.point !== null).forEach(grade => {
        const gradePoint = grade.adjustedPoint ?? grade.point;
        totalManagement += (gradePoint / 2) * grade.weight;
        maxManagement += 5 * grade.weight;
    });

    return {
        totalManagementGrade: totalManagement,
        maxManagementGrade: maxManagement,
        computedManagementGrade: Math.round((totalManagement / maxManagement) * 100)
    }
}

const calculateConditionGrade = (grades: Grade[]) => {
    let totalCondition = 0;
    let maxCondition = 0;

    grades.filter(grade => grade.type === GRADE_TYPE_CONDITION && grade.point !== null).forEach(grade => {
        const gradePoint = grade.adjustedPoint ?? grade.point;
        totalCondition += (gradePoint / 2) * grade.weight;
        maxCondition += 5 * grade.weight;
    });

    return {
        totalConditionGrade: totalCondition,
        maxConditionGrade: maxCondition,
        computedConditionGrade: Math.round((totalCondition / maxCondition) * 100)
    }
}

export const calculateGrades = (grades: Grade[]) => {
    const managementGrade = calculateManagementGrade(grades);
    const conditionGrade = calculateConditionGrade(grades);

    const totalGrade = managementGrade.totalManagementGrade + conditionGrade.totalConditionGrade;
    const maxGrade = managementGrade.maxManagementGrade + conditionGrade.maxConditionGrade;

    const overallGrade = Math.round(((totalGrade / maxGrade) * 100));

    return {
        managementGrade,
        conditionGrade,
        overallGrade
    }
}

export const combineAdjustedGrades = (inspectionVesselGrades: Grade[], adjustedGrades: AdjustedGrade[]) => {
    if (!adjustedGrades || adjustedGrades.length === 0) {
        return inspectionVesselGrades;
    }

    const combinedGrades: Grade[] = [];
    inspectionVesselGrades.forEach(grade => {
        const adjustedGrade = adjustedGrades.find(adjustedGrade => adjustedGrade.vesselGradeId === grade.vesselGradeId);

        if (grade.point !== null && grade.point !== undefined && adjustedGrade && adjustedGrade.gradeValue !== null && adjustedGrade.gradeValue !== undefined) {
            combinedGrades.push({
                ...grade,
                adjustedPoint: adjustedGrade.gradeValue / 10
            });
        } else if (grade.point !== null && grade.point !== undefined) {
            combinedGrades.push(grade);
        }
    });

    return combinedGrades;
}

export const adjustedGradesDto = (adjustedGrades: Grade[]) => {
    return adjustedGrades.filter(grade => grade.point !== null).map(grade => {
        return {
            vesselGradeId: grade.vesselGradeId,
            gradeValue: grade.adjustedPoint !== undefined ? grade.adjustedPoint * 10 : grade.point * 10,
            point: grade.point,
            adjustedPoint: grade.adjustedPoint
        }
    });
}